import React from "react";
import { toAbsoluteUrl } from "../_metronic/_helpers";

export const CurrencyLogo = ({
  symbol,
  variant = "dark",
  height = 16,
  className = "mb-05",
}) => {
  if (!symbol) return null;

  return (
    <img
      src={toAbsoluteUrl(`media/svg/currencyLogos/${symbol}-${variant}.svg`)}
      height={height}
      className={className}
      alt={`${symbol} currency`}
    />
  );
};
